import { observer } from 'mobx-react-lite'
import {
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  ComposedChart,
} from 'recharts'
import type { ConversationsChartDataStore } from 'pages/analytics/pages/conversations/ui/Chart/store/conversationsChartDataStore'
import { calculateYAxisWidth, getMaxValueFromData } from 'pages/analytics/lib/calculateYAxisWidth'
import styles from 'pages/analytics/pages/conversations/ui/Chart/ui/styles.module.scss'

interface ConversationsLineChartProps {
  chartDataStore: ConversationsChartDataStore
}

export const ConversationsLineChart = observer(
  ({ chartDataStore }: ConversationsLineChartProps) => {
    const { rechartsData } = chartDataStore

    const maxValue = getMaxValueFromData<Record<string, unknown>>(
      rechartsData as unknown as Record<string, unknown>[],
      'new'
    )
    const yAxisWidth = calculateYAxisWidth(maxValue)

    return (
      <div className={styles.chartContainer}>
        <ResponsiveContainer width='100%' height={300}>
          <ComposedChart data={rechartsData} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <defs>
              <linearGradient id='colorGradient' x1='0' y1='0' x2='0' y2='1'>
                <stop offset='0%' stopColor='var(--content-brand-primary)' stopOpacity={0.3} />
                <stop offset='100%' stopColor='var(--content-brand-primary)' stopOpacity={0.05} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray='3 3' vertical={false} />
            <XAxis dataKey='name' interval='preserveStartEnd' minTickGap={1} />
            <YAxis width={yAxisWidth} />
            <Tooltip />
            <Area
              type='monotone'
              dataKey='new'
              stroke='var(--content-brand-primary)'
              fill='url(#colorGradient)'
              strokeWidth={0}
              tooltipType='none'
            />
            <Line
              type='monotone'
              dataKey='new'
              stroke='var(--content-brand-primary)'
              strokeWidth={2}
              name='New conversations'
              dot={false}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    )
  }
)
